/* src/index.css */
/* The rest of your custom CSS can go below */
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./globals.css";
// 1. Import the Provider and your store
import { Provider } from "react-redux";
import store from "./redux/store"; // Make sure this path points to your store.ts file!

ReactDOM.render(
  <React.StrictMode>
    {/* 2. Wrap the App in the Provider */}
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root"),
);
